import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IHeaderCommon } from '@carnica/smart-kit';
import mergeDeep from 'deepmerge';

import { headerClient } from 'api';

export const fetchHeaderModel2024 = createAsyncThunk('headerCommon/fetchHeaderModel2024', () => {
  return headerClient.request<IHeaderCommon>({
    path: '/headermodel2024/',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    retries: 5,
    delay: 1000,
  });
});

const initialState: {
  loaded: boolean;
} & IHeaderCommon = {
  additionalLinks: [],
  currentRegion: {},
  isMobileDevice: false,
  search: undefined,
  theme: 'secondary',
  loaded: false,
};

const commonSlice = createSlice({
  name: 'headerCommon',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchHeaderModel2024.fulfilled, (state, { payload }) => {
      return { ...mergeDeep(state, payload), loaded: true };
    });
  },
});

export default commonSlice.reducer;
